import {UrlBuilder} from "../../../common/utils/url";
import {html, LitElement, type TemplateResult} from "lit";
import {customElement, property, query} from "lit/decorators.js";
import Styles from "./newsTagLink.lit.scss";
import {SEARCH_QUERY_PARAMETER_NAME} from "./constants";
import {resolve} from "../../../container";
import {Resolution} from "../../../common/resolution";
import {ShadowHighlightContextAware} from "../../../common/elements";
import {trackingTextlinkInteract} from "../../../tracking/trackingAttributes";

@customElement("eop-news-tag-link")
export class EopNewsTagLink extends ShadowHighlightContextAware(LitElement) {

    public static readonly styles = Styles;

    @property()
    private url: string;
    @property()
    private text: string;

    @query(".tag-container")
    protected tagContainer: HTMLElement;

    public constructor(
        protected resolution: Resolution = resolve(Resolution)) {
        super();
    }

    public render(): TemplateResult {
        const url = this.getTargetUrl();

        return html`
            <div class="tag-container reverse-background">
                <a href=${url} class="tag" ${trackingTextlinkInteract(this.text, url)}>${this.text}</a>
            </div>
        `;
    }

    private getTargetUrl(): string {
        return new UrlBuilder(this.url)
            .withQueryParameter(SEARCH_QUERY_PARAMETER_NAME, this.text)
            .build();
    }
}